module.exports = __webpack_public_path__ + "static/media/global.8a4336ca.svg";